/* tslint:disable */
/* eslint-disable */
/**
 * Xerjoff.Agenti.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProvinciaDTO
 */
export interface ProvinciaDTO {
    /**
     * 
     * @type {string}
     * @memberof ProvinciaDTO
     */
    codice?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProvinciaDTO
     */
    descrizione?: string | null;
}

/**
 * Check if a given object implements the ProvinciaDTO interface.
 */
export function instanceOfProvinciaDTO(value: object): value is ProvinciaDTO {
    return true;
}

export function ProvinciaDTOFromJSON(json: any): ProvinciaDTO {
    return ProvinciaDTOFromJSONTyped(json, false);
}

export function ProvinciaDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProvinciaDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'codice': json['codice'] == null ? undefined : json['codice'],
        'descrizione': json['descrizione'] == null ? undefined : json['descrizione'],
    };
}

  export function ProvinciaDTOToJSON(json: any): ProvinciaDTO {
      return ProvinciaDTOToJSONTyped(json, false);
  }

  export function ProvinciaDTOToJSONTyped(value?: ProvinciaDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'codice': value['codice'],
        'descrizione': value['descrizione'],
    };
}

